import React from 'react';
import { withApollo } from "react-apollo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { clientCredentials } from '../../graphql/queries'
import { toggleVote } from '../../graphql/mutations'


class CommentVote extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			voteNum: 0,
			userVote: 0 //@TODO show if true
		}

    	this.handleVote = this.handleVote.bind(this);
	}

	componentDidMount() {

		const votes = this.props.votes || [];
		
		this.setState({ voteNum: votes.length });
		const { clientCredentials : credentials } = this.props.client.readQuery({query: clientCredentials});
		
		for(let vote of votes) {
			if(credentials.id === vote.user.id) {
				this.setState({ userVote: 1 });
				break;
			}
		}
	}

	handleVote(e) {

		const qlVars = {
			post: this.props.commentId
		};
		
		this.props.client.mutate({
			mutation: toggleVote,
			variables: qlVars
		})
		.then(res => {
			const voteNum = res.data.toggleVote;
			this.setState({ 
				voteNum: voteNum, 
				userVote: 1 - this.state.userVote
			});
		})
		.catch(e => {
			alert('Vote Error: ' + e);
		});
	}

	render() {

		const title = this.props.votes.map(vote => vote.user.name).join(', ');
		let classButton = 'button button--icon comment-subicon';
		if(this.state.userVote) classButton += ' comment-subicon--active';

		return (
			<button onClick={this.handleVote} className={classButton} title={title}>
				{this.state.voteNum !== 0 && <span style={{marginRight: '0.375rem'}}>{this.state.voteNum}</span>}
				<FontAwesomeIcon icon="heart" />
			</button>
		)
	}
}


export default withApollo(CommentVote)


// WEBPACK FOOTER //
// ./src/components/comment/CommentVote.js